export const DEFAULT_MAX_AGE = 30 as const
